const initialState = {
  status: {},
  isLoading: false,
  isSidebarCollapsed: false,
  uploadedFileName: "",
  activeFilePath: "",
  uploadedImageName: "",
  activeCsvHeaders: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_ERROR":
      return setStatus(state, action);
    case "SET_LOADER":
      return setLoader(state, action);
    case "SET_SIDEBAR_COLLAPSED":
      return setSideBarCollapsed(state, action);
    case "SET_UPLOADED_FILE_NAME":
      return setUploadedFileName(state, action);
    case "SET_ACTIVE_FILE_PATH":
      return setActiveFilePath(state, action);
    case "SET_UPLOADED_IMAGE_NAME":
      return setUploadedImageName(state, action);
    case "SET_UPLOADED_VIDEO_NAME":
      return setUploadedVideoName(state, action);
    case "SET_ACTIVE_CSV_HEADERS":
      return setActiveCsvHeaders(state, action);
    default:
      return state;
  }
}

const setStatus = (state, action) => {
  return {
    ...state,
    status: action.payload,
  };
};

const setLoader = (state, action) => {
  return {
    ...state,
    isLoading: action.payload,
  };
};

const setSideBarCollapsed = (state, action) => {
  return {
    ...state,
    isSidebarCollapsed: action.payload,
  };
};
const setUploadedFileName = (state, action) => {
  return {
    ...state,
    uploadedFileName: action.payload,
  };
};
const setActiveFilePath = (state, action) => {
  return {
    ...state,
    activeFilePath: action.payload,
  };
};
const setUploadedImageName = (state, action) => {
  return {
    ...state,
    uploadedImageName: action.payload,
  };
};
const setUploadedVideoName = (state, action) => {
  return {
    ...state,
    uploadedVideoName: action.payload,
  };
};
const setActiveCsvHeaders = (state, action) => {
  return {
    ...state,
    activeCsvHeaders: action.payload,
  };
};
